import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../actions/index.types';
import * as req from '../../../../axios/request/SocietyController/CtrlBrandReqs/CtrlBrandReqs';
import { notify } from '../../../../utils/notification';

/* =========================
   GET COMMUNITY LIST
========================= */
function* getBrands(action) {
    try {
        const result = yield call(req.getBrandListReq, action);

        if (result?.success === true) {
            yield put({
                type: types.CTRL_BRAND_LIST_SUCCESS,
                payload: result
            });
        } else {
            notify('error', result?.message);
            yield put({
                type: types.CTRL_BRAND_LIST_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.CTRL_BRAND_LIST_FAILURE,
            message: e?.message
        });
    }
}

// /* =========================
//    GET COMMUNITY DETAILS
// ========================= */
function* getBrandDetails(action) {
    try {
        const result = yield call(req.getBrandDetailsReq, action);
        if (result?.success === true) {
            yield put({
                type: types.CTRL_GET_BRAND_SUCCESS,
                payload: result
            });
        } else {
            notify('error', result?.message);
            yield put({
                type: types.CTRL_GET_BRAND_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.CTRL_GET_BRAND_FAILURE,
            message: e?.message
        });
    }
}

// /* =========================
//    CREATE COMMUNITY
// ========================= */
function* createBrand(action) {
    try {
        const result = yield call(req.createBrandReq, action);

        if (result?.success === true) {
            notify('success', result.message);
            yield put({
                type: types.CTRL_CREATE_BRAND_SUCCESS,
                payload: result
            });
            action?.data?.onSuccess()
        } else {
            notify('error', result?.message);
            yield put({
                type: types.CTRL_CREATE_BRAND_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.CTRL_CREATE_BRAND_FAILURE,
            message: e?.message
        });
    }
}

// /* =========================
//    EDIT COMMUNITY
// ========================= */
function* editBrand(action) {
    try {
        const result = yield call(req.editBrandReq, action);

        if (result?.success === true) {
            notify('success', result.message);
            yield put({
                type: types.CTRL_EDIT_BRAND_SUCCESS,
                payload: result
            });
            action?.data?.onSuccess();
        } else {
            notify('error', result?.message);
            yield put({
                type: types.CTRL_EDIT_BRAND_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.CTRL_EDIT_BRAND_FAILURE,
            message: e?.message
        });
    }
}

// /* =========================
//    DELETE COMMUNITY
// ========================= */
function* deleteBrand(action) {
    try {
        const result = yield call(req.deleteBrandReq, action);

        if (result?.success === true) {
            notify('success', result.message);
            yield put({
                type: types.CTRL_DELETE_BRAND_SUCCESS,
                payload: result
            });
            // Refresh list after delete
            action?.data?.onSuccess();
        } else {
            notify('error', result?.message);
            yield put({
                type: types.CTRL_DELETE_COMMUNITY_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        yield put({
            type: types.CTRL_DELETE_COMMUNITY_FAILURE,
            message: e?.message
        });
    }
}

/* =========================
   ROOT COMMUNITY SAGA
========================= */
export default function* ctrlBrandSaga() {
    yield takeLatest(types.CTRL_BRAND_LIST, getBrands);
    yield takeLatest(types.CTRL_GET_BRAND, getBrandDetails);
    yield takeLatest(types.CTRL_CREATE_BRAND, createBrand);
    yield takeLatest(types.CTRL_EDIT_BRAND, editBrand);
    yield takeLatest(types.CTRL_DELETE_BRAND, deleteBrand);
}
